import { atom } from "recoil";

export const imageGalleryHasZoomAtom = atom<boolean>({
  key: "imageGalleryHasZoomAtom",
  default: false,
});

export const imageGalleryCursorAtom = atom<"default" | "zoom-in" | "zoom-out">({
  key: "imageGalleryCursorAtom",
  default: "default",
});

export const imageGalleryImageZoomTransformAtom = atom<{ x: number; y: number; scale: number }>({
  key: "imageGalleryImageZoomTransformAtom",
  default: { x: 0, y: 0, scale: 1 },
});
